export const VendorManagementRoutes = {
  path: 'VendorManagement',
  name: 'Vendor Management',
  component: () => import('@/views/VendorManagement/VendorManagementView.vue'),
  meta: { modulePermission: 'VendorManagement' },
  children: [
    {
      path: '',
      component: () => import('@/views/VendorManagement/VendorTiles.vue'),
    },
    {
      path: 'Vendors',
      name: 'Vendors',
      component: () => import('@/views/VendorManagement/VendorsList.vue'),
      meta: { modulePermission: 'Vendors' },
    },
    {
      path: 'Jobs',
      name: '',
      children: [
        {
          path: '',
          name: 'Jobs',
          component: () => import('@/views/VendorManagement/JobConfig/JobsListView.vue'),
          meta: { modulePermission: 'JobConfigurations' },
        }
      ]
    },
    {
      path: 'Vendor/:id',
      name: 'Vendor',
      props: true,
      component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
      meta: { title: 'Vendor Profile' },
      children: [
        {
          path: 'Overview',
          name: 'Overview',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
          meta: { title: 'Overview' },
        },
        {
          path: 'Contacts',
          name: 'Vendor Contacts',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorContacts.vue'),
          meta: { title: 'Vendor Contacts' },
        },
        {
          path: 'JobConfigurations',
          name: 'Job Configurations',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
          meta: { title: 'Job Configurations' },
        },
        {
          path: 'SFTPConfigurations',
          name: 'SFTP Configurations',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
          meta: { title: 'SFTP Configurations' },
          children: [
            {
              path: ':id/SFTPDetails',
              name: 'SFTP Details',
              props: true,
              component: () => import('@/views/VendorManagement/VendorDetails/TabContents/SftpDetails.vue'),
              meta: { title: 'SFTP Configuration Details' },
            },
          ],
        },
        {
          path: 'PGPConfigurations',
          name: 'PGP Configurations',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
          meta: { title: 'PGP Configurations' },
        },
        {
          path: 'FileJobLog',
          name: 'File Job Log',
          props: false,
          component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
          meta: { title: 'File Job Log' },
        },
      ],
    },
    {
      path: 'Vendor/:id/ConfigurationTemplates',
      name: 'Configuration Templates',
      props: true,
      component: () => import('@/views/VendorManagement/VendorDetails/VendorDetails.vue'),
      meta: { title: 'Configuration Templates' },
    },
    {
      path: 'FileMapping',
      name: 'File Mapping',
      props: false,
      component: () => import('@/views/VendorManagement/FileMapping.vue'),
      meta: { title: 'File Mapping' },
      children: [
        {
          path: 'AddEditFileMapping/:fileMapId?',
          name: 'Add Edit File Mapping',
          props: false,
          component: () => import('@/views/VendorManagement/FileMapping/AddEditFileMapping.vue'),
          meta: { title: 'Add Edit File Mapping' },
        },
      ],
    },
    {
      path: 'Crosswalks',
      name: 'Crosswalks',
      props: false,
      component: () => import('@/views/VendorManagement/Crosswalk/CrosswalkListView.vue'),
      meta: { title: 'Crosswalks' },
    },
    {
      path: 'Crosswalks/Crosswalk/:crosswalkId?',
      name: 'Add Edit Crosswalk',
      props: false,
      component: () => import('@/views/VendorManagement/Crosswalk/AddEditCrosswalk.vue'),
      meta: { title: 'Add Edit Crosswalk' },
    },
    {
      path: 'VendorLogs',
      name: 'Vendor Logs',
      component: () => import('@/views/VendorManagement/FileJobLogs/FileJobLogsView.vue'),
      meta: { title: 'Vendor Logs' },
    },
  ],
};
